import { Reveal, SectionHead } from "./Reveal";

export default function HowItWorks({ steps }) {
  return (
    <section id="how-it-works" className="relative bg-[#F2EFE9] py-24 lg:py-32" data-testid="how-it-works-section">
      <div className="pointer-events-none absolute right-0 top-1/3 h-[400px] w-[500px] rounded-full bg-[#0E8A8A]/5 blur-[120px]" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          index="02"
          label="How It Works"
          title="From signup to first commission in a day."
          description="No paperwork queues, no waiting weeks for activation. Three steps and your shop becomes a banking point."
          testId="how-it-works-head"
        />
        <div className="space-y-0">
          {(steps || []).map((step, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div
                className="group grid gap-4 border-t border-[#E2DDD5] py-10 transition-colors duration-300 last:border-b hover:bg-white/50 sm:grid-cols-12 sm:items-baseline sm:gap-8"
                data-testid={`step-${i}`}
              >
                <span className="font-mono text-sm font-semibold text-[#B8860B] sm:col-span-2">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-syne text-xl font-semibold text-[#0F1B2B] transition-colors duration-300 group-hover:text-[#0E8A8A] sm:col-span-4 sm:text-2xl">
                  {step.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#5A6578] sm:col-span-6 sm:text-base">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
